import { ScrcpyOptions1_24 } from "../1_24.js";
import { ScrcpyScrollController1_25 } from "./scroll.js";
export class ScrcpyOptions1_25 extends ScrcpyOptions1_24 {
    getScrollController() {
        return new ScrcpyScrollController1_25();
    }
}
//# sourceMappingURL=options.js.map